import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';
import state from '@/core/state';
import { getMemberInfo } from '@/core/http/api';

const AGENT_ROLE_ID = 5;
const isAgent = memberInfo => Number(memberInfo?.role_id) === AGENT_ROLE_ID;

// Rebate setting is only available to agents.
async function agentGuard(to, from, next) {
    if (!localStorage.getItem('gamingToken')) return next();
    if (Number(state.memberInfo.role_id)) {
        return next(isAgent(state.memberInfo) ? undefined : '/profile');
    }
    try {
        const res = await getMemberInfo();
        const info = res.data?.data;
        if (info) state.memberInfo = info;
        next(isAgent(info) ? undefined : '/profile');
    } catch {
        next();
    }
}

export default defineModule({
    id: 'rebate',
    routes: [
        {
            path: '/rebate-setting',
            name: 'rebateSetting',
            meta: { requiresAuth: true },
            beforeEnter: agentGuard,
            component: overridable('RebateSettingPage', () => import(/* webpackChunkName: "rebate" */ './views/RebateSettingPage.vue'))
        }
    ],
    contributes: {
        'profile.links': [
            {
                key: 'rebateSetting',
                order: 20,
                to: '/rebate-setting',
                iconPath: 'M19 5L5 19M9 6.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM20 17.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
                label: 'profile.rebateSetting',
                desc: 'profile.manageRebateSetting',
                when: ({ memberInfo }) => isAgent(memberInfo)
            }
        ]
    }
});
